(() => {
  const key = 'karigari.saved.handles.v1';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const readSaved = () => {
    try { const value = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(value) ? value.filter((item) => typeof item === 'string') : []; }
    catch (_) { return []; }
  };
  const writeSaved = (handles) => { try { localStorage.setItem(key, JSON.stringify(handles)); } catch (_) {} };
  const updateSavedUI = () => {
    const handles = readSaved();
    document.querySelectorAll('[data-stitch-save]').forEach((button) => {
      const saved = handles.includes(button.dataset.stitchSave);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      if (button.classList.contains('stitch-pdp-save')) {
        button.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
      } else button.textContent = saved ? '♥' : '♡';
    });
    document.querySelectorAll('[data-stitch-wishlist-count]').forEach((node) => { node.textContent = handles.length ? String(handles.length) : ''; });
  };
  const escapeHTML = (text) => String(text ?? '').replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-stitch-save]');
    if (!button) return;
    const handle = button.dataset.stitchSave;
    if (!handle) return;
    const handles = readSaved();
    writeSaved(handles.includes(handle) ? handles.filter((item) => item !== handle) : [...handles, handle]);
    updateSavedUI();
    if (document.querySelector('[data-stitch-wishlist-page]')) renderWishlist();
  });

  const money = (cents) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(Number(cents || 0) / 100);
  const renderWishlist = async () => {
    const page = document.querySelector('[data-stitch-wishlist-page]');
    if (!page) return;
    const empty = page.querySelector('[data-stitch-wishlist-empty]');
    const grid = page.querySelector('[data-stitch-wishlist-grid]');
    const error = page.querySelector('[data-stitch-wishlist-error]');
    const handles = readSaved();
    empty.hidden = handles.length > 0;
    grid.hidden = !handles.length;
    error.hidden = true;
    if (!handles.length) { grid.innerHTML = ''; return; }
    grid.setAttribute('aria-busy', 'true');
    grid.innerHTML = '<p>Loading saved kits…</p>';
    try {
      const products = await Promise.all(handles.map(async (handle) => {
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
        return response.ok ? response.json() : null;
      }));
      const available = products.filter(Boolean);
      grid.innerHTML = available.map((product) => {
        const image = product.featured_image ? `<img src="${escapeHTML(product.featured_image)}" alt="${escapeHTML(product.title)}" loading="lazy" width="400" height="400">` : '';
        const first = product.variants && product.variants.find((variant) => variant.available);
        const buyAction = !first ? '<span>Currently unavailable</span>' : product.variants.length === 1 ? `<button type="button" data-stitch-saved-add="${first.id}">Add to bag</button>` : `<a class="stitch-experience__button" href="${root}products/${encodeURIComponent(product.handle)}">Choose options</a>`;
        return `<article class="stitch-experience__card"><a href="${root}products/${encodeURIComponent(product.handle)}">${image}</a><div class="stitch-experience__card-body"><h3><a href="${root}products/${encodeURIComponent(product.handle)}">${escapeHTML(product.title)}</a></h3><p>${money(product.price)}</p><div class="stitch-experience__card-actions">${buyAction}<button type="button" data-stitch-save="${escapeHTML(product.handle)}" aria-label="Remove ${escapeHTML(product.title)} from saved kits" aria-pressed="true">Remove</button></div></div></article>`;
      }).join('') || '<p>These products are no longer available. Explore the shop for a new project.</p>';
    } catch (_) { grid.innerHTML = ''; error.hidden = false; }
    finally { grid.removeAttribute('aria-busy'); }
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-stitch-saved-add]');
    if (!button) return;
    button.disabled = true;
    const label = button.textContent;
    button.textContent = 'Adding…';
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(button.dataset.stitchSavedAdd), quantity: 1 }) });
      if (!response.ok) throw new Error('Add failed');
      button.textContent = 'Added!';
      const cartResponse = await fetch(`${root}cart.js`);
      if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-stitch-cart-count]').forEach((node) => { node.textContent = cart.item_count || ''; }); }
    } catch (_) { button.textContent = 'Try again'; }
    window.setTimeout(() => { button.disabled = false; button.textContent = label; }, 2000);
  });

  const quiz = document.querySelector('[data-stitch-quiz]');
  if (quiz) {
    let step = 0;
    const answers = ['','',''];
    const steps = [...quiz.querySelectorAll('[data-stitch-quiz-step]')];
    const progress = quiz.querySelector('[data-stitch-quiz-progress]');
    const back = quiz.querySelector('[data-stitch-quiz-back]');
    const next = quiz.querySelector('[data-stitch-quiz-next]');
    const results = quiz.querySelector('[data-stitch-quiz-results]');
    const showStep = () => {
      steps.forEach((node, index) => { node.hidden = index !== step; });
      progress.textContent = `Question ${step + 1} of 3`;
      back.hidden = step === 0;
      next.disabled = !answers[step];
      next.textContent = step === 2 ? 'See my matches →' : 'Next →';
    };
    quiz.addEventListener('click', (event) => {
      const choice = event.target.closest('[data-quiz-value]');
      if (choice) {
        answers[step] = choice.dataset.quizValue;
        steps[step].querySelectorAll('[data-quiz-value]').forEach((node) => node.setAttribute('aria-pressed', node === choice ? 'true' : 'false'));
        next.disabled = false;
      }
    });
    back.addEventListener('click', () => { if (step > 0) { step -= 1; showStep(); } });
    next.addEventListener('click', () => {
      if (!answers[step]) return;
      if (step < 2) { step += 1; showStep(); return; }
      quiz.querySelector('[data-stitch-quiz-steps]').hidden = true;
      quiz.querySelector('.stitch-quiz__actions').hidden = true;
      progress.textContent = 'Your matches';
      results.hidden = false;
      const products = [...quiz.querySelectorAll('[data-quiz-product]')];
      const budget = answers[2] === 'any' ? Infinity : Number(answers[2]) * 100;
      const inBudget = products.filter((node) => Number(node.dataset.price) <= budget);
      const matching = inBudget.filter((node) => node.dataset.search.includes(answers[1]));
      const candidates = matching.length ? matching : inBudget;
      const picks = candidates.sort((a, b) => {
        const score = (node) => {
          const text = node.dataset.search;
          const people = answers[0] === 'solo' ? ['solo', 'me time', 'beginner'] : answers[0] === 'couple' ? ['date', 'couple', 'together'] : answers[0] === 'family' ? ['kids', 'family', 'child'] : ['friends', 'party', 'group'];
          return people.reduce((total, word) => total + (text.includes(word) ? 1 : 0), 0);
        };
        return score(b) - score(a);
      }).slice(0, 6);
      const grid = quiz.querySelector('[data-stitch-quiz-grid]');
      grid.replaceChildren(...picks.map((node) => node.cloneNode(true)));
      if (!picks.length) grid.innerHTML = `<p>No kits match this budget right now. <a href="${root}collections/all">Browse all available kits</a> or try another budget.</p>`;
      results.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    });
    quiz.querySelector('[data-stitch-quiz-restart]').addEventListener('click', () => {
      step = 0; answers.fill('');
      quiz.querySelectorAll('[data-quiz-value]').forEach((node) => node.setAttribute('aria-pressed', 'false'));
      quiz.querySelector('[data-stitch-quiz-steps]').hidden = false;
      quiz.querySelector('.stitch-quiz__actions').hidden = false;
      results.hidden = true; showStep();
      quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  updateSavedUI();
  renderWishlist();
})();
